import { round } from 'lodash';
import { STATIC_ASSETS_URL } from 'constants/index';
import { EMPTY_USER_IMAGE_PATH, CUSTOM_SYSTEM_PHOTOS, UserThumbnailSize } from 'constants/images';

const getEmptyUserImage = () => EMPTY_USER_IMAGE_PATH;

const getSystemUserImage = (portal, flavour) => {
  const portalCode = portal.replace('_sandbox', '');
  const name = CUSTOM_SYSTEM_PHOTOS.includes(portalCode) ? portalCode : 'default';
  return "".concat(STATIC_ASSETS_URL, "/assets/no-photo/user-").concat(flavour, "/system-photo/").concat(name, ".png");
};

const getUserThumbnail = function getUserThumbnail(photo) {
  let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : UserThumbnailSize.Default;
  if (!photo) return getEmptyUserImage();
  if (!photo.thumbnails) return getEmptyUserImage();
  const thumbnail = photo.thumbnails.find(thumb => thumb.type === size);
  if (!thumbnail) return getEmptyUserImage();
  return thumbnail.url;
};

const getPhotoThumbnail = function getPhotoThumbnail(photo) {
  let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : UserThumbnailSize.Default;
  if (!photo) return getEmptyUserImage();
  if (!photo.thumbnails) return getEmptyUserImage();
  const thumbnail = photo.thumbnails.find(thumb => thumb.type === size);
  if (!thumbnail) return getEmptyUserImage();
  return thumbnail.url;
};

const calculateRating = reputation => round(reputation * 5, 2);

const getUserLocationDescription = user => {
  const {
    expose_location,
    city,
    country_title_local
  } = user;

  if (expose_location && city) {
    return "".concat(city, ", ").concat(country_title_local);
  }

  return country_title_local;
};

export { getEmptyUserImage, getSystemUserImage, getPhotoThumbnail, getUserThumbnail, calculateRating, getUserLocationDescription };